module.exports = __webpack_public_path__ + "img/03-rocket-over-shadow-over-rocket.a03b137a.png";